import { useMutation, useQueryClient } from "@tanstack/react-query";
import { disconnectGoogle } from "../api/auth";

// One grant backs the Gmail / Calendar / Contacts rows, so a disconnect
// must refresh everything that reads it: the aggregate (the /integrations
// page, the top-bar pill and the Gmail tile share one cache entry) and
// the workspace tiles.
export function useGoogleDisconnect() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: disconnectGoogle,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["integrations", "status"] }),
        queryClient.invalidateQueries({ queryKey: ["firm", "workspace"] }),
        queryClient.invalidateQueries({ queryKey: ["gmail"] }),
      ]);
    },
  });
}
